/*******************************************************************
* PAGE        : reduxMasterSlice
* REMARKS     : Comman Redux Master Slice
* CREATED ON  : 06-01-2026
* AUTHOR      : Bamroliya.Paras
* MODIFY      : Bamroliya.Paras
* MODIFY ON   : 04-02-2026
********************************************************************/

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    userMasterId: null,
    refreshToken: null,
    userMasterIdentification: null,
    isAuthenticated: false,
    sidebarMenu: [],
    allowedRoutes: [],
    masterArray: {},
    selectedItem: null,
    loginInfo: {},
    isLoading: false,
    notificationCountByUser: {}
};

const reduxMasterSlice = createSlice({
    name: 'DataCMExpress',
    initialState,
    reducers: {

        setUserMasterId: (state, action) => { state.userMasterId = action.payload; }, // SET MASTER ID

        setRefreshToken: (state, action) => { state.refreshToken = action.payload; }, // SET MASTER ID

        setUserMasterIdentification: (state, action) => { state.userMasterIdentification = action.payload; }, // SET MASTER ID

        setIsAuthenticated: (state, action) => { state.isAuthenticated = action.payload; }, // SET AUTHENTICATION STATUS

        setSidebarMenu: (state, action) => { state.sidebarMenu = action.payload; }, // SET SIDEBAR MENU

        setAllowedRoutes: (state, action) => { state.allowedRoutes = action.payload; }, // SET ALLOWED ROUTES

        setMasterArray: (state, action) => { state.masterArray = action.payload; }, // SET FULL ARRAY


        // addToMasterArray: (state, action) => { state.masterArray.push(action.payload); }, // ADD SINGLE ITEM

        // // UPDATE ITEM BY ID
        // updateMasterItem: (state, action) => {
        //     const { id, updatedData } = action.payload;
        //     const index = state.masterArray.findIndex(item => item.id === id);

        //     if (index !== -1) {
        //         state.masterArray[index] = { ...state.masterArray[index], ...updatedData, };
        //     }
        // },

        // deleteMasterItem: (state, action) => { state.masterArray = state.masterArray.filter(item => item.id !== action.payload); }, // DELETE ITEM

        addToMasterArray: (state, action) => {
            const { name, data } = action.payload;
            state.masterArray[name] = data;   // now valid
        },

        updateMasterItem: (state, action) => {
            const { name, updatedData } = action.payload;
            if (state.masterArray[name]) {
                state.masterArray[name] = updatedData;
            }
        },

        deleteMasterItem: (state, action) => { delete state.masterArray[action.payload]; }, // payload = name

        setSelectedItem: (state, action) => { state.selectedItem = action.payload; }, // SET SELECTED ITEM

        resetMasterState: () => initialState,// RESET ALL
        setNotificationCountByUser: (state, action) => {
            const { userId, count } = action.payload;

            if (!state.notificationCountByUser) {
                state.notificationCountByUser = {};
            }

            state.notificationCountByUser[userId] = count;
        }
    },
});

export const {
    setUserMasterId,
    setRefreshToken,
    setUserMasterIdentification,
    setIsAuthenticated,
    setSidebarMenu,
    setAllowedRoutes,
    setMasterArray,
    addToMasterArray,
    updateMasterItem,
    deleteMasterItem,
    setSelectedItem,
    resetMasterState,
    setNotificationCountByUser
} = reduxMasterSlice.actions;

export default reduxMasterSlice.reducer;
